export const IMAGE_TYPE = Object.freeze({
  LOGO: 'circle',
  FULLSCREEN: 'gallery',
});
